// validators purely cater TypeScript and do no actual work.
// instead of defining types with flag keys and objects that implement them,
// validator functions type objects with a generic type(FlagType) while keeping a limited set of allowed keys.
var createFlagValidator = function () {
    return function (v) {
        return v;
    };
};
/**
 * All feature flags must be listed here, regardless if they exist in LaunchDarkly or client-side only
 */
export var flags = createFlagValidator()({
    'autopayout-self-serve': false,
    'group-appointments': false,
    'use-forethought-chat': false,
    'use-salesforce-messaging-sessions': false,
    'share-brand-customers-to-rental-barbers': true,
    'apple-agreement-banner': false,
    'shop-onboarding': false,
    'walk-in-list': false,
    'client-reviews': false,
    'stripe-hosted-onboarding': false,
    'payment-deposits-enabled': false,
    'lockdown-instant-payout': false,
    'brand-tax-auto-save': false,
    fullstory: true,
    'fullstory-calendar-flow': false,
    'fullstory-clients-flow': false,
    'fullstory-register-flow': false,
    'client-referrals': false,
    '2fa-enable': false,
    '2fa-enable-announcement': false,
    'engage-for-barbers': false,
    'engage-sharing-banner': false,
    'engage-for-chair-renters': false,
    'account-restricted-soon-announcement': false,
    '2fa-phase-one': false,
    'engage-gen-ai-enabled': false,
    'engage-concierge-enabled': false,
    'hybrid-expose-rent-collect': false,
    'brand-level-analytics-management': false,
    'brand-level-meta-pixel-management': false,
    'hybrid-staff-payments-tab': false,
    'automated-campaigns-banner': false,
    'automated-campaigns': false,
    'ai-phone-assistant': false,
    'reporting-bot': false,
    'engage-new-filters': false,
});
/**
 * This utility object is supposed to provide easy access to flag names in JS code
 * where we don't have types to guide us. It's not supposed to be used in TS code.
 * The object is intentionally explicitly written instead of being generated from the `flags` object
 * to make autocomplete work in JS code.
 */
export var flagNames = {
    AUTOPAYOUT_SELF_SERVE: 'autopayoutSelfServe',
    GROUP_APPOINTMENTS: 'groupAppointments',
    CLIENT_REVIEWS: 'clientReviews',
    USE_FORETHOUGHT_CHAT: 'useForethoughtChat',
    USE_SALESFORCE_MESSAGING_SESSIONS: 'useSalesforceMessagingSessions',
    SHARE_BRAND_CUSTOMERS_TO_RENTAL_BARBERS: 'shareBrandCustomersToRentalBarbers',
    APPLE_AGREEMENT_BANNER: 'appleAgreementBanner',
    SHOP_ONBOARDING: 'shopOnboarding',
    WALK_IN_LIST: 'walkInList',
    STRIPE_HOSTED_ONBOARDING: 'stripeHostedOnboarding',
    PAYMENT_DEPOSITS_ENABLED: 'paymentDepositsEnabled',
    LOCKDOWN_INSTANT_PAYOUT: 'lockdownInstantPayout',
    BRAND_TAX_AUTO_SAVE: 'brandTaxAutoSave',
    FULLSTORY: 'fullstory',
    FULLSTORY_CALENDAR_FLOW: 'fullstoryCalendarFlow',
    FULLSTORY_CLIENTS_FLOW: 'fullstoryClientsFlow',
    FULLSTORY_REGISTER_FLOW: 'fullstoryRegisterFlow',
    CLIENT_REFERRALS: 'clientReferrals',
    '2FA_ENABLE': '2FaEnable',
    '2FA_ENABLE_ANNOUNCEMENT': '2FaEnableAnnouncement',
    ENGAGE_FOR_BARBERS: 'engageForBarbers',
    ENGAGE_FOR_CHAIR_RENTERS: 'engageForChairRenters',
    ENGAGE_SHARING_BANNER: 'engageSharingBanner',
    ACCOUNT_RESTRICTED_SOON_ANNOUNCEMENT: 'accountRestrictedSoonAnnouncement',
    '2FA_PHASE_ONE': '2FaPhaseOne',
    HYBRID_EXPOSE_RENT_COLLECT: 'hybridExposeRentCollect',
    BRAND_LEVEL_ANALYTICS_MANAGEMENT: 'brandLevelAnalyticsManagement',
    BRAND_LEVEL_META_PIXEL_MANAGEMENT: 'brandLevelMetaPixelManagement',
    HYBRID_STAFF_PAYMENTS_TAB: 'hybridStaffPaymentsTab',
    ENGAGE_GEN_AI_ENABLED: 'engageGenAiEnabled',
    ENGAGE_CONCIERGE_ENABLED: 'engageConciergeEnabled',
    AUTOMATED_CAMPAIGNS_BANNER: 'automatedCampaignsBanner',
    AUTOMATED_CAMPAIGNS: 'automatedCampaigns',
    AI_PHONE_ASSISTANT: 'aiPhoneAssistant',
    REPORTING_BOT: 'reportingBot',
    ENGAGE_NEW_FILTERS: 'engageNewFilters',
};
// this is a no-op function that only validates that the flag names are in sync with the flags object
var validateFlagNames = function (namesMap) { return namesMap; };
validateFlagNames(flagNames);
